module.exports = __webpack_public_path__ + "img/profit-report (1).fdce8b6f.svg";